<template>
    <div class="sbs-checkbox-group">
        <div class="sbs-radio-group__content">
            <!-- @slot Слот по-умолчанию для компонентов `SbsCheckbox` -->
            <slot></slot>
        </div>

        <!-- @slot Слот для вывода ошибок -->
        <slot
            name="error"
            v-bind="{
                rules,
                valid,
                value: modelValue,
            }">
            <span
                v-if="invalid"
                class="sbs-checkbox-group__error-message">
                <SbsIcon
                    v-bind="errorIconData"
                    class="sbs-checkbox-group__error-icon" />
                {{ errorMessage || defaultErrorMessage }}
            </span>
        </slot>
    </div>
</template>

<script>
import validationMixin from '../../mixins/validation.js';
import { AllColors } from '../../utils/colors.js';
import { AllSizes } from '../../utils/sizes.js';
import { AllIconGroups } from '../icon/utils/consts.js';

/**
 * Компонент для группы `SbsCheckbox`.
 * Позволяет сделать выбор нескольких вариантов из множества.
 * Принимает значение текущего активного элемента/элементов
 */
export default {
    name: 'SbsCheckboxGroup',
    mixins: [validationMixin],
    provide() {
        return {
            checkboxGroupComponent: this,
        };
    },
    emits: ['update:modelValue', 'valid', 'invalid'],
    computed: {
        errorIconData() {
            return {
                iconName: 'exclamation',
                iconGroup: AllIconGroups.SOLID,
                iconSize: AllSizes.SMALL,
                colorTheme: AllColors.WHITE,
                backgroundTheme: AllColors.GRADIENT_PINK,
            };
        },
    },
    methods: {
        async checkboxChangeHandler(value) {
            this.dirty = true;

            /**
             * Событие `change` срабатывает при изменении значения группы чекбоксов.
             * В качестве параметра - значение после изменения
             */
            this.$emit('update:modelValue', value);

            if (!this.noValidate) {
                await this.validate(value);
            }
        },
    },
    props: {
        /**
         * Перевод в неактивное состояние
         */
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Поле для вывода ошибок
         */
        errorMessage: {
            type: String,
            default: '',
        },
        /**
         * Скрывает элемент управления
         */
        hideControl: {
            type: Boolean,
            default: false,
        },
        /**
         * Включает расположение элементов в строку
         */
        inline: {
            type: Boolean,
            default: false,
        },
        /**
         * Название радиобаттона, используется для объединения в общую группу
         */
        name: {
            type: String,
            default: '',
        },
        /**
         * Текущий выбранный чекбокс
         * @model
         */
        modelValue: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style lang="scss">
.sbs-checkbox-group {
    display: flex;
    flex-direction: column;

    &__error-message {
        margin-top: 8px;
        color: $danger;

        @include typo-subsecondary-demi;
    }

    &__error-icon {
        width: 15px;
        height: 15px;
        margin-right: 5px;
        border-radius: $rounded-circle;
    }
}
</style>
